module.exports = __webpack_public_path__ + "img/block.4a52fdfd.svg";